import PropTypes from 'prop-types';
import React, { Component } from 'react';
import SortLink from '../SortLink';

class JobsTableHeader extends Component {

    constructor(props) {
        super(props);
        this.sortData = this.sortData.bind(this);
        this.getClasses = this.getClasses.bind(this);
    }

    /**
     * give every Sortlink sort__link class and selected class if the link was clicked
     * @param fieldValue == field value of the SortLink
     * @returns string with the css classes for the Sortlink
     */
    getClasses(fieldValue) {
        const selectedClass = this.props.sort.field === fieldValue ? 'selected' : '';
        return `${selectedClass} sort__link`;
    }

    /**
     *
     * @returns 'opposite' of the active sort direction
     */
    getInvertedDirection() {
        return this.props.sort.direction === '-' ? '+' : '-';
    }

    /**
     *
     * @param field == key from the jobs reducer jobsList.items
     */
    sortData(field) {
        let direction = '+';
        if (this.props.sort.field === field) {
            direction = this.getInvertedDirection();
        }
        this.props.onChange(field, direction);
    }

    render() {
        const { field, direction } = this.props.sort;
        return (
            <thead>
            <tr>
                <th>
                    <SortLink
                        field="created"
                        label="Erstellt am"
                        getClasses={this.getClasses}
                        sortData={this.sortData}
                        fieldValue={field}
                        direction={direction}
                    />
                </th>
                <th>
                    <SortLink
                        field="offerDeadline"
                        label="Angebotsabg. bis"
                        getClasses={this.getClasses}
                        sortData={this.sortData}
                        fieldValue={field}
                        direction={direction}
                    />
                </th>
                <th className="status-column">
                    <SortLink
                        field="status"
                        label="Status"
                        getClasses={this.getClasses}
                        sortData={this.sortData}
                        fieldValue={field}
                        direction={direction}
                    />
                </th>
                <th>
                    <SortLink
                        field="name"
                        label="Bezeichnung"
                        getClasses={this.getClasses}
                        sortData={this.sortData}
                        fieldValue={field}
                        direction={direction}
                    />
                </th>

                <th>
                    <SortLink
                        field="customerName"
                        label="Kunde"
                        getClasses={this.getClasses}
                        sortData={this.sortData}
                        fieldValue={field}
                        direction={direction}
                    />
                </th>
                <th>
                    Baustelle
                </th>
                <th>
                    Gerüste
                </th>
            </tr>
            </thead>
        );
    }

}

export default JobsTableHeader;

JobsTableHeader.propTypes = {
    onChange: PropTypes.func
};

JobsTableHeader.defaultProps = {
    onChange: () => false
};
